import React from "react";
import './Lenguaje.css';
import { Link } from 'react-router-dom';
import {useTranslation} from "react-i18next"


export default function Lenguaje(){

    const [traslate,i18n] = useTranslation("global");

    return(
        <div className="lenguaje">
            <h1 className="fa fa-globe">Languaje</h1>
            <div className="banderas">
              
                    <Link to='/' onClick={()=>i18n.changeLanguage("es")}>
                        <button>Español</button>
                      
                    </Link>
                
             
                    <Link to='/' onClick={()=>i18n.changeLanguage("en")}>

                        <button className='btn-eng'>English</button>
                    </Link>
              
            </div>
        </div>

    );
}